export default "__VITE_ASSET__3240d6bc__"